
export default {

    setPage(state, page) {
        state.page = page;
    },
}